registerComponent("blocks/input", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Um comportamento só: a classe `full` no `.box-input` enquanto o campo tem
 * conteúdo. É ela que sobe o label flutuante (`&.full .input + .label` em
 * `_input.less`) — sem ela o label fica por cima do que a pessoa digitou.
 *
 * `input` no lugar do `keyup` de 2020: `keyup` não dispara em colagem pelo
 * menu do botão direito, em autopreenchimento nem em ditado, e o label ficava
 * por cima do texto até a tecla seguinte. A chamada inicial (era o
 * `.trigger('keyup')`) continua existindo, e é ela que cobre o campo que
 * nasce preenchido — o `q` da busca em `/busca?q=…`.
 */

const campo = component.querySelector('input');
const caixa = component.querySelector('.box-input');

if (campo && caixa) {
    const marcar = () => caixa.classList.toggle('full', Boolean(campo.value));

    campo.addEventListener('input', marcar);
    campo.addEventListener('blur', marcar);

    marcar();
}

});
